'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var scales = _ref.scales;

  var defaultAppearance = _themer.Themer.createTabAppearance({
    base: {},
    hover: {
      backgroundColor: scales.neutral.N2A
    },
    focus: {
      boxShadow: '0 0 0 2px ' + scales.primary.P5A
    },
    active: {
      backgroundColor: scales.primary.P3A,
      color: scales.primary.P9
    },
    current: {}
  });

  /**
   * Get the appearance of a `Tab`.
   * @param {string} appearance
   * @return {string} the appearance object.
   */
  var getTabAppearance = function getTabAppearance() {
    return defaultAppearance;
  };

  /**
   * Get the className of a `Tab`.
   * @param {string} appearance
   * @return {string} the appearance class name.
   */
  return (0, _memoizeClassName2.default)(getTabAppearance);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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